// app/(main)/ai-design-center/lib/constants.ts
import { v4 as uuid } from 'uuid'
import { ISidebarLink } from './types'

export const aiDesignCenterLinks: ISidebarLink[] = [
  {
    title: 'Back to Waltz',
    path: '/',
    id: uuid(),
    isHeader: true
  },
  {
    title: 'AI Design Center',
    path: '/ai-design-center/main',
    id: uuid(),
    icon: '/images/ai-design-center-icon.svg',
    className: 'text-[#FE6434]'
  },
  {
    title: 'Generate AI Image',
    path: '/ai-design-center/generate-image',
    id: uuid(),
    icon: '/images/generate-ai-image-icon.svg'
  },
  {
    title: 'Image Editor',
    path: '/ai-design-center/generate-image',
    id: uuid(),
    icon: '/images/image-editor-icon.svg'
  },
  // {
  //   title: 'AI Social Media',
  //   path: '',
  //   id: uuid(),
  //   icon: "/images/ai-social-media-icon.svg"
  // },
  {
    title: 'Manage Assets',
    path: '/ai-design-center/manage-assets',
    id: uuid(),
    icon: '/images/manage-assets-icon.svg'
  }
]

export const tools = [
  {
    title: 'AI Image Generation',
    image: '/images/ai-image-generation-interface.png',
    path: '/ai-design-center/generate-image'
  },
  {
    title: 'Image Editor',
    image: '/images/image-editor.png',
    path: '/ai-design-center/image-editor'
  },
  {
    title: 'Social Media Generation',
    image: '/images/social-media.png',
    path: '/ai-design-center/social-media'
  },
  {
    title: 'Manage Assets',
    image: '/images/manage-assets.png',
    path: '/ai-design-center/manage-assets'
  }
]
export const categories = [
  { label: 'Waltz Generations', value: 'all' },
  { label: 'My AI Generations', value: 'mygenerated' }
]

export enum Feature {
  IMAGE_GENERATION = 'image-generation',
  IMAGE_GENERATION_ULTRA = 'image-generation-ultra',
  IMAGE_GENERATION_SUPER = 'image-generation-super',
  IMAGE_EDITING = 'image-editing',
  IMAGE_EDITING_RETOUCH = 'image-editing-retouch',
  IMAGE_EDITING_ERASE = 'image-editing-erase',
  EMAIL_SENDING = 'email-sending',
  WEB_PAGE_GENERATION = 'web-page-generation',
  WEB_PAGE_GENERATION_MULTI = 'web-page-generation-multi',
  WEB_PAGE_GENERATION_LANDING = 'web-page-generation-landing',
  WEB_PAGE_EDITING = 'web-page-editing'
}

export const CREDIT_COSTS: Record<Feature, number> = {
  [Feature.IMAGE_GENERATION]: 4,
  [Feature.IMAGE_GENERATION_ULTRA]: 2,
  [Feature.IMAGE_GENERATION_SUPER]: 1,
  [Feature.IMAGE_EDITING]: 15,
  [Feature.IMAGE_EDITING_RETOUCH]: 5,
  [Feature.IMAGE_EDITING_ERASE]: 1,
  [Feature.EMAIL_SENDING]: 0.04,
  [Feature.WEB_PAGE_GENERATION]: 50,
  [Feature.WEB_PAGE_GENERATION_MULTI]: 60,
  [Feature.WEB_PAGE_GENERATION_LANDING]: 30,
  [Feature.WEB_PAGE_EDITING]: 6
}
